import { GetItemResult } from '@idmc-ms-fabric/integration';
import { ElasticSearchHit } from '@infa-hawk/services/src/services/ccgf-searchv2/ElasticService.types';
import { ISourceSystemElement, ITicketInfo } from '@infa-service/cdgc-connection';
import { ITask, JobStatus } from '@infa-service/mdp-orchestration-api';

import { ConnectionDetail, SupportedCatalogSourceType } from '../../../utils/catalog-source/catalog-source';
import { API_STATUS } from '../../../utils/common-types';

export type ParentDetails = {
	element: ISourceSystemElement;
	size: number;
	id: string;
};
export type SelectedTable = {
	id: string;
	name: string;
	hierarchy: string[];
	filterValue?: string;
	filterType?: string;
	catalogExternalId?: string;
	schemaDetail?: ParentDetails;
};

export type SelectedColumn = {
	id: string;
	name: string;
};
export type JobDetails = {
	status?: JobStatus;
	tasks?: ITask[];
	filters?: string[];
};
export type IDQAPageState = {
	status: API_STATUS;
	artifactDetails?: GetItemResult;
	errorMessage?: string;
	id?: string;
	catalogSrc?: {
		id: string;
		name: string;
		type: SupportedCatalogSourceType;
		connectionDetails: ConnectionDetail;
	};
	table?: SelectedTable;
	column?: ElasticSearchHit;
	runningJobDetails?: JobDetails;
	browseTicketDetails?: ITicketInfo;
};

export enum IDQAPageAction {
	UPDATE_CS,
	SELECT_TABLE,
	SELECT_COLUMN,
	UPDATE_JOB,
	UPDATE_TASKS,
	INIT_ERROR,
	INIT_SUCCESS,
	INIT_LOADING,
	UPDATE_JOB_STATUS,
	REMOVE_TABLE_DETAILS,
	SET_ARTIFACT_DETAILS,
}
